"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _merge = _interopRequireDefault(require("merge"));

var _formView = _interopRequireDefault(require("./../form-view"));

var _translate = _interopRequireDefault(require("./../translate"));

var _advancedFetch = _interopRequireDefault(require("../../lib/advanced-fetch"));

var _equalizer = _interopRequireDefault(require("../../lib/equalizer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var defaultData = {
  h: '',
  gd: -1,
  sh: -1,
  x: '',
  c: '',
  al1: '',
  al2: '',
  lb: '',
  rh: '',
  t: '',
  m2: '',
  q8: '',
  colorProfile: -1
};
var defaultTexts = {
  calculate: '',
  optics: '',
  pleaseChoose: '',
  h: '',
  gd: '',
  sh: '',
  x: '',
  c: '',
  al1: '',
  al2: '',
  lb: '',
  rh: '',
  t: '',
  gloss: '',
  alu: '',
  colorProfile: '',
  profileColorless: '',
  profileBlack: '',
  selection: null
};
var tableHeadings = {
  orderList: {
    articleName: 'Bestellliste Schiebetechnik, Profile und Dichtungen',
    articleNumber: 'Art.Nr',
    quantity: 'Stk.'
  },
  layoutList: {
    articleName: 'Zuschnittliste Profile und Dichtungen',
    articleNumber: 'Art.Nr',
    quantity: 'Stk.',
    length: 'Länge'
  },
  glasElementList: {
    articleName: 'Bestellliste Glas-Elemente',
    quantity: 'Stk.',
    height: 'Höhe',
    width: 'Breite'
  },
  doorWidthList: {
    articleName: 'Türbreite',
    width: 'Breite'
  }
};

var calculateTbByLb = function calculateTbByLb(lb, config) {
  lb = parseFloat(lb);
  var summand = config.tuerBreite.summand;
  var subtrahend = config.tuerBreite.subtrahend;
  var divisor = config.tuerBreite.divisor;
  var outerSummand = config.tuerBreite.outerSummand;

  if (subtrahend) {
    return parseFloat((lb - subtrahend) / divisor + outerSummand);
  }

  return parseFloat((lb + summand) / divisor + outerSummand);
};

var calculateTb2ByAl = function calculateTb2ByAl(al2, config) {
  al2 = parseFloat(al2);
  var summand = config.tuerBreite2.summand;
  var divisor = config.tuerBreite2.divisor;
  var subtrahend = config.tuerBreite2.subtrahend;
  var outerSummand = config.tuerBreite2.outerSummand;

  if (subtrahend) {
    return parseFloat((al2 - subtrahend) / divisor + outerSummand);
  }

  return parseFloat((al2 + summand) / divisor + outerSummand);
};

var calculateXByLb = function calculateXByLb(lb, config) {
  lb = parseFloat(lb);
  var tb = calculateTbByLb(lb, config);
  var subtrahend = config.x.subtrahend;
  return lb - tb - subtrahend;
};

var calculateXByAl = function calculateXByAl(al1, al2, config) {
  al1 = parseFloat(al1);
  al2 = parseFloat(al2);
  var tb1 = calculateTbByLb(al1, config);
  var tb2 = calculateTb2ByAl(al2, config);
  var al1Subtrahend = config.x.al1Subtrahend;
  var al1Power = config.x.al1Power;
  var al2Subtrahend = config.x.al2Subtrahend;
  var al2Power = config.x.al2Power;
  var power = config.x.power;
  var al1Result = Math.pow(al1 - tb1 - al1Subtrahend, al1Power);
  var al2Result = Math.pow(al2 - tb2 - al2Subtrahend, al2Power);
  return Math.round(Math.pow(al1Result + al2Result, power) * 100) / 100;
};
/**
 *
 */


var FormContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(FormContainer, _React$Component);

  function FormContainer(props) {
    var _this;

    _classCallCheck(this, FormContainer);

    _this = _possibleConstructorReturn(this, (FormContainer.__proto__ || Object.getPrototypeOf(FormContainer)).call(this, props));
    _this.state = {
      texts: defaultTexts,
      config: {},
      colorProfile: [],
      gd: [],
      sh: [],
      invalidFields: [],
      graphDisplay: [],
      data: defaultData,
      showTable: false,
      calculations: {},
      tableData: {
        data: {},
        headings: tableHeadings
      },
      articles: {}
    };
    _this.onChangeData = _this.onChangeData.bind(_assertThisInitialized(_this));
    _this.onFieldBlur = _this.onFieldBlur.bind(_assertThisInitialized(_this));
    _this.save = _this.save.bind(_assertThisInitialized(_this));
    _this.reset = _this.reset.bind(_assertThisInitialized(_this));
    _this.updateTexts = _this.updateTexts.bind(_assertThisInitialized(_this));
    _this.generatePdf = _this.generatePdf.bind(_assertThisInitialized(_this));
    _this.resetRh = _this.resetRh.bind(_assertThisInitialized(_this));
    _this.getHError = _this.getHError.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(FormContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _equalizer.default)();
      this.load();
    }
    /**
     *
     * @params prevProps
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      (0, _equalizer.default)();

      if (prevProps.lng !== this.props.lng) {
        var t = this.props.t;
        this.setState(function (prev) {
          prev.invalidFields = prev.invalidFields.map(function (invalidField) {
            invalidField.label = t(invalidField.message);
            return invalidField;
          });
          return prev;
        }, this.updateTexts);
      }
    }
    /**
     *
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var addonTitle = this.state.data.selection === 'cornerSolution' ? 'Hawa Banio 40 GFE' : 'Hawa Banio 40 GF';
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-form-container grid-x relative-grid'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9 heading-area"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "back-link hide-for-print",
        href: "/",
        onClick: this.reset
      }, t('back button')), /*#__PURE__*/_react.default.createElement("h1", null, addonTitle, " ", t(this.state.data.selection)))), this.state.data.selection && this.renderForm());
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "renderForm",
    value: function renderForm() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_formView.default, {
        save: this.save,
        formConfig: this.state.config,
        texts: this.state.texts,
        invalidFields: this.state.invalidFields,
        graphConfig: this.state.graphDisplay,
        onFieldBlur: this.validate,
        data: this.state.data,
        colorProfileOptions: this.state.colorProfile,
        glasThicknessOptions: this.state.gd,
        heightOptions: this.state.sh,
        changeData: this.onChangeData,
        leaveField: this.onFieldBlur,
        buttonDisabled: !this.buttonEnabled(this.state.data),
        showTable: this.state.showTable,
        tableData: this.state.tableData,
        generatePdf: this.generatePdf,
        getHError: this.getHError,
        resetRh: this.resetRh,
        t: t
      });
    }
  }, {
    key: "resetRh",
    value: function resetRh() {
      this.setState(function (prev) {
        prev.data.rh = '';
        prev.invalidFields.map(function (invalidObject, index) {
          if (invalidObject.fieldName === 'rh') {
            delete prev.invalidFields[index];
          }
        });
        return prev;
      });
    }
  }, {
    key: "getHError",
    value: function getHError() {
      var t = this.props.t;
      this.setState(function (prev) {
        prev.invalidFields.push({
          fieldName: 'rh',
          message: t('Der Wert RH muss grösser sein als H'),
          label: t('Der Wert RH muss grösser sein als H')
        });
        return prev;
      });
    }
    /**
     *
     */

  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      fetch('/api/form', {
        credentials: 'include'
      }).then(_advancedFetch.default).then(function (response) {
        if (response.next) {
          _this2.props.history.push(response.next);

          throw new Error('Done');
        }

        _this2.setState(function (prev) {
          prev.config = response.config.form;
          prev.articles = response.config.articles;
          prev.graphDisplay = response.config.graphDisplay;
          prev.data = _merge.default.recursive(true, prev.data, response.data, response.config);
          prev.gd = response.config.form.gd.exact.map(function (gd) {
            return {
              label: gd + 'mm',
              key: gd
            };
          });
          prev.sh = [{
            label: 'Raumhöhe',
            key: 1
          }, {
            label: 'Duschenhöhe',
            key: 0
          }];
          prev.colorProfile = response.config.form.colorProfile.exact.map(function (cp) {
            return {
              label: cp === 0 ? 'Alu' : 'Glanz',
              key: cp
            };
          });
          prev.showTable = false;
          prev.tableData.data = {};
          prev.calculations = {};
          return prev;
        }, _this2.updateTexts);
      }).catch(function (err) {
        if (err.message !== 'Done') {
          if (err.status !== 404) {
            void 0;
          }
        }
      });
    }
    /**
     *
     */

  }, {
    key: "save",
    value: function save(e) {
      var _this3 = this;

      e.preventDefault();
      var data = {}; // clean data: send only fields which are expected by the server. read from config.

      Object.keys(this.state.data).forEach(function (keyInData) {
        if (_this3.state.config.fields.indexOf(keyInData) !== -1) {
          data[keyInData] = _this3.state.data[keyInData];
        }
      });
      fetch('/api/form', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(_advancedFetch.default).then(function (response) {
        if (response.next === '/') document.location.href = '/';
        if (response.next === '/pdf') document.location.href = 'debug/pdf/A4_3Graphics';

        if (response.next === '/table') {
          _this3.setState(function (prev) {
            prev.showTable = true;
            prev.calculations = _merge.default.recursive(true, prev.calculations, response.data);
            prev.tableData.data = response.data.articles || {};
            return prev;
          });
        }
      }).catch(function (err) {
        if (err.error && err.error.status === 422 && err.error.invalidFields) {
          _this3.setState(function (prev) {
            prev.invalidFields = err.error.invalidFields.map(function (invalidField) {
              invalidField.label = _this3.props.t(invalidField.message, {});
              return invalidField;
            });
            return prev;
          });
        }

        void 0;
      });
    }
  }, {
    key: "generatePdf",
    value: function generatePdf(e) {
      e.preventDefault();
      window.open('pdf/A4', '_blank');
    }
    /**
     *
     * @param e
     */

  }, {
    key: "reset",
    value: function reset(e) {
      var _this4 = this;

      e.preventDefault();
      fetch('/api/form', {
        credentials: 'include',
        method: 'DELETE'
      }).then(_advancedFetch.default).then(function (response) {
        if (response.next) _this4.props.history.push(response.next);
      }).catch(function (err) {
        void 0;
      });
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "onChangeData",
    value: function onChangeData(fieldName, value) {
      this.setState(function (prev) {
        prev.data[fieldName] = value;
        var _prev$data = prev.data,
            lb = _prev$data.lb,
            al1 = _prev$data.al1,
            al2 = _prev$data.al2;
        prev.data.x = '';

        if (lb) {
          prev.data.x = calculateXByLb(lb, prev.data.table.calc.base);
        }

        if (al1 && al2) {
          prev.data.x = calculateXByAl(al1, al2, prev.data.table.calc.base);
        }

        return prev;
      });
    }
    /**
     *
     * @param targetFieldName
     * @param e
     */

  }, {
    key: "onFieldBlur",
    value: function onFieldBlur(targetFieldName, e) {
      var t = this.props.t;

      if (e.target.checkValidity()) {
        this.setState(function (prev) {
          prev.invalidFields = prev.invalidFields.filter(function (_ref) {
            var fieldName = _ref.fieldName;
            return fieldName !== targetFieldName;
          });
          return prev;
        });
      } else {
        var errorKey = 'The value of this field is out of range.';
        this.setState(function (prev) {
          prev.invalidFields = prev.invalidFields.filter(function (_ref2) {
            var fieldName = _ref2.fieldName;
            return fieldName !== targetFieldName;
          });
          prev.invalidFields.push({
            fieldName: targetFieldName,
            message: errorKey,
            label: t(errorKey)
          });
          return prev;
        });
      }
    }
    /**
     * Enable button if all fields are filled
     *
     * @returns {boolean}
     */

  }, {
    key: "buttonEnabled",
    value: function buttonEnabled() {
      var _this5 = this;

      var mandatory = this.state.config.mandatory;
      return mandatory.every(function (key) {
        if (['sh', 'gd', 'colorProfile'].indexOf(key) >= 0) {
          return _this5.state.data[key] !== -1;
        }

        return !!_this5.state.data[key];
      });
    }
    /**
     *
     */

  }, {
    key: "updateTexts",
    value: function updateTexts() {
      var t = this.props.t;
      var lengthUnit = t('mm');
      this.setState(function (prev) {
        prev.colorProfile[1].label = t('Alu');
        prev.colorProfile[0].label = t('Glanz');
        prev.sh[1].label = t('Duschenhöhe');
        prev.sh[0].label = t('Raumhöhe');
        prev.texts = {
          calculate: t('Berechnen'),
          pleaseChoose: t('Please choose'),
          gd: t('Variante'),
          colorProfile: t('Glanz'),
          optics: t('optics'),
          lb: t('label lb', {
            unit: lengthUnit
          }),
          h: t('label h', {
            unit: lengthUnit
          }),
          c: t('label c', {
            unit: lengthUnit
          }),
          x: t('label x', {
            unit: lengthUnit
          }),
          al1: t('label al1', {
            unit: lengthUnit
          }),
          al2: t('label al2', {
            unit: lengthUnit
          }),
          rh: t('label rh', {
            unit: lengthUnit
          }),
          t: t('label t', {
            unit: lengthUnit
          })
        };
        return prev;
      });
    }
  }]);

  return FormContainer;
}(_react.default.Component);

FormContainer.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  lng: PropTypes.string.isRequired
};

var _default = (0, _translate.default)(FormContainer);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-container/index.js
// module id = 551
// module chunks = 0